/**
 * APH Rewards signup - Builder B (Kimi)
 * Real account creation: create_customer posts to /account, which on
 * this store (new Customer Accounts) enters Shopify's email-code
 * verify flow (probe 2026-09-23: 302 -> shopify.com/<id>/account
 * ?login_hint=email, password ignored). JS intercepts the submit,
 * posts via fetch with redirect: 'manual' (same-origin, no CORS
 * follow), then swaps the form in place for the green check. No
 * customer_posted contact form, no hash scroll, no navigation.
 * Fallback: if fetch fails, a plain native submit still lands the
 * visitor on Shopify's verification screen.
 */
(function () {
  'use strict';

  function initForm(form) {
    if (form.dataset.arwBound) return;
    form.dataset.arwBound = '1';

    var wrap = form.closest('.aph-rewards-copy') || form.parentElement;
    var success = wrap ? wrap.querySelector('[data-arw-success]') : null;
    var submitBtn = form.querySelector('[type="submit"]');

    form.addEventListener('submit', function (e) {
      if (form.dataset.arwNative === '1') return; /* native fallback resubmit */
      e.preventDefault();
      if (submitBtn) submitBtn.disabled = true;

      fetch(form.getAttribute('action') || '/account', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'manual'
      }).then(function () {
        /* /account answered (302 into the OTP flow) - customer identity
           is registered and Shopify sends the verification code. */
        form.hidden = true;
        if (success) success.hidden = false;
      }).catch(function () {
        /* Network-level failure: fall back to a real native submit so
           the visitor still reaches Shopify's verification screen. */
        form.dataset.arwNative = '1';
        if (submitBtn) submitBtn.disabled = false;
        form.submit();
      });
    });
  }

  function boot() {
    document.querySelectorAll('.js-arw-form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) {
      e.target.querySelectorAll('.js-arw-form').forEach(function (f) {
        delete f.dataset.arwBound;
        initForm(f);
      });
    }
  });
})();
